export const WEDDING_TEMPLATES = [
  {
    id: 'classic-editorial',
    name: 'Classic Editorial',
    label: 'Clássico Editorial',
    collection: 'Biblioteca Essencial',
    description: 'Convite editorial clássico, simétrico e cerimonial.',
    preview_image: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=800',
    colors: { primary: '#3A3732', secondary: '#E9D7B4' },
    style: 'classico'
  },
  {
    id: 'botanical-garden',
    name: 'Botanical Garden',
    label: 'Botanical Garden',
    collection: 'Biblioteca Essencial',
    description: 'Romântico orgânico com hero split e narrativa leve.',
    preview_image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800',
    colors: { primary: '#2E5243', secondary: '#B8D5C1' },
    style: 'jardim'
  },
  {
    id: 'modern-black-tie',
    name: 'Modern Black Tie',
    label: 'Modern Black Tie',
    collection: 'Biblioteca Essencial',
    description: 'Layout assimétrico premium com contraste forte e status rail.',
    preview_image: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=800',
    colors: { primary: '#111318', secondary: '#C8A96B' },
    style: 'luxo'
  },
  {
    id: 'destination-praia',
    name: 'Destination Praia',
    label: 'Destination Praia',
    collection: 'Biblioteca Essencial',
    description: 'Experiência arejada com foco em roteiro e local do evento.',
    preview_image: 'https://images.unsplash.com/photo-1545579133-99bb5ab189bd?w=800',
    colors: { primary: '#5A8CA8', secondary: '#E9D8B8' },
    style: 'praia'
  },
  {
    id: 'minimal-classic',
    name: 'Minimal Classic',
    label: 'Minimal Classic',
    collection: 'Biblioteca Essencial',
    description: 'Minimalismo editorial com tipografia e respiro visual.',
    preview_image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800',
    colors: { primary: '#2F2E2E', secondary: '#D7BE8A' },
    style: 'minimalista'
  },
  {
    id: 'vintage-retro',
    name: 'Vintage Retro',
    label: 'Vintage Retrô',
    collection: 'Biblioteca Essencial',
    description: 'Estética retrô editorial com tons quentes, história em duas colunas e faixa de galeria.',
    preview_image: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800',
    colors: { primary: '#704214', secondary: '#C4922A' },
    style: 'vintage'
  },
  {
    id: 'scandinavian-minimal',
    name: 'Escandinavo',
    label: 'Escandinavo',
    collection: 'Biblioteca Essencial',
    description: 'Minimalismo escandinavo com contraste frio, tipografia leve e detalhes em faixa.',
    preview_image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800',
    colors: { primary: '#1A1A1A', secondary: '#4A90A4' },
    style: 'minimalista'
  },
  {
    id: 'por-do-sol',
    name: 'Pôr do Sol',
    label: 'Pôr do Sol',
    collection: 'Biblioteca Essencial',
    description: 'Romance solar com gradiente quente, tipografia editorial e galeria em faixa.',
    preview_image: 'https://images.unsplash.com/photo-1545579133-99bb5ab189bd?w=800',
    colors: { primary: '#1A0A04', secondary: '#E8603A' },
    style: 'praia'
  },
  {
    id: 'noir-dorado',
    name: 'Noir Dorado',
    label: 'Noir Dorado',
    collection: 'Biblioteca Essencial',
    description: 'Noir sofisticado com ouro, molduras cerimoniais e atmosfera noturna.',
    preview_image: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800',
    colors: { primary: '#0A0804', secondary: '#C9A84C' },
    style: 'luxo'
  },
  {
    id: 'terra-flores',
    name: 'Terra & Flores',
    label: 'Terra & Flores',
    collection: 'Biblioteca Essencial',
    description: 'Boho orgânico com tons terrosos, split hero e narrativa floral.',
    preview_image: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800',
    colors: { primary: '#8B6347', secondary: '#6B7C5C' },
    style: 'boho'
  },
  {
    id: 'linha-pura',
    name: 'Linha Pura',
    label: 'Linha Pura',
    collection: 'Biblioteca Essencial',
    description: 'Minimalismo editorial com linhas finas, números grandes e muito respiro.',
    preview_image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800',
    colors: { primary: '#0D0D0D', secondary: '#6B6B6B' },
    style: 'minimalista'
  },
  {
    id: 'jardim-secreto',
    name: 'Jardim Secreto',
    label: 'Jardim Secreto',
    collection: 'Biblioteca Essencial',
    description: 'Jardim secreto com split verde, convite central e detalhes botânicos.',
    preview_image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800',
    colors: { primary: '#1C2E1A', secondary: '#8FAB7E' },
    style: 'jardim'
  },
  {
    id: 'art-deco',
    name: 'Art Déco',
    label: 'Art Déco',
    collection: 'Biblioteca Essencial',
    description: 'Art déco preto e dourado com moldura geométrica e leitura premium.',
    preview_image: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=800',
    colors: { primary: '#0C0C08', secondary: '#D4AF37' },
    style: 'luxo'
  },
  {
    id: 'praia-brisa',
    name: 'Praia & Brisa',
    label: 'Praia & Brisa',
    collection: 'Biblioteca Essencial',
    description: 'Praia leve com bolhas, onda de transição e leitura solar.',
    preview_image: 'https://images.unsplash.com/photo-1545579133-99bb5ab189bd?w=800',
    colors: { primary: '#1B4F72', secondary: '#5DADE2' },
    style: 'praia'
  },
  {
    id: 'inverno-real',
    name: 'Inverno Real',
    label: 'Inverno Real',
    collection: 'Biblioteca Essencial',
    description: 'Elegância de inverno com azul profundo, prata e cartões frios.',
    preview_image: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=800',
    colors: { primary: '#0D1F3C', secondary: '#B8C4CC' },
    style: 'classico'
  },
  {
    id: 'veludo-rosa',
    name: 'Veludo Rosa',
    label: 'Veludo Rosa',
    collection: 'Biblioteca Essencial',
    description: 'Veludo rosado com hero split, pétalas abstratas e presença fashion.',
    preview_image: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=800',
    colors: { primary: '#8B2252', secondary: '#D4688A' },
    style: 'romantico'
  },
  {
    id: 'tipo-gigante',
    name: 'Tipo Gigante',
    label: 'Tipo Gigante',
    collection: 'Biblioteca Essencial',
    description: 'Template tipográfico com letras gigantes, marquee e contraste editorial.',
    preview_image: 'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=800',
    colors: { primary: '#0A0A0A', secondary: '#F0C040' },
    style: 'moderno'
  },
  {
    id: 'sakura',
    name: 'Sakura Japonês',
    label: 'Sakura Japonês',
    collection: 'Biblioteca Essencial',
    description: 'Inspiração japonesa com sakura, composição vertical e contraste suave.',
    preview_image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800',
    colors: { primary: '#1A0A0A', secondary: '#E8A0B0' },
    style: 'romantico'
  },
  {
    id: 'serra-nevoa',
    name: 'Serra & Névoa',
    label: 'Serra & Névoa',
    collection: 'Biblioteca Essencial',
    description: 'Serra, névoa e montanhas em uma composição calma e natural.',
    preview_image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800',
    colors: { primary: '#4A5568', secondary: '#718096' },
    style: 'campo'
  },
  {
    id: 'parisiense',
    name: 'Parisiense',
    label: 'Parisiense',
    collection: 'Biblioteca Essencial',
    description: 'Editorial parisiense com preto suave, dourado discreto e elegância limpa.',
    preview_image: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=800',
    colors: { primary: '#2C2C2C', secondary: '#C4A25A' },
    style: 'classico'
  },
  {
    id: 'tropical',
    name: 'Tropical',
    label: 'Tropical',
    collection: 'Biblioteca Essencial',
    description: 'Tropical refinado com verde profundo, amarelo solar e ar de jardim.',
    preview_image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800',
    colors: { primary: '#1A4731', secondary: '#F5C842' },
    style: 'tropical'
  },
  {
    id: 'prata-eterno',
    name: 'Prata Eterno',
    label: 'Prata Eterno',
    collection: 'Biblioteca Essencial',
    description: 'Minimalismo prata e preto com leitura atemporal.',
    preview_image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800',
    colors: { primary: '#1A1A1A', secondary: '#C0C0C0' },
    style: 'minimalista'
  },
  {
    id: 'bohemia',
    name: 'Bohemia',
    label: 'Bohemia',
    collection: 'Biblioteca Essencial',
    description: 'Bohemia quente com terracota, dourado e textura editorial.',
    preview_image: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800',
    colors: { primary: '#C4622D', secondary: '#D4A017' },
    style: 'boho'
  },
  {
    id: 'noite-estrelada',
    name: 'Noite Estrelada',
    label: 'Noite Estrelada',
    collection: 'Biblioteca Essencial',
    description: 'Noite estrelada em azul profundo com acentos dourados.',
    preview_image: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800',
    colors: { primary: '#0A0E1A', secondary: '#D4B84A' },
    style: 'luxo'
  },
  {
    id: 'azulejo-portugues',
    name: 'Azulejo Português',
    label: 'Azulejo Português',
    collection: 'Biblioteca Essencial',
    description: 'Azulejo português com azul clássico, dourado e composição elegante.',
    preview_image: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=800',
    colors: { primary: '#1B4B82', secondary: '#C4902A' },
    style: 'classico'
  },
  {
    id: 'ethereal-grid',
    name: 'The Ethereal Grid',
    label: 'Minimalista Luxo',
    collection: 'Editoriais, Modernos e Moda',
    description: 'Editorial grid minimalista com off-white, charcoal e champagne.',
    preview_image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800',
    colors: { primary: '#2F2E2E', secondary: '#D7BE8A' },
    style: 'minimalista'
  },
  {
    id: 'asymmetric-flow',
    name: 'The Asymmetric Flow',
    label: 'Contemporâneo',
    collection: 'Editoriais, Modernos e Moda',
    description: 'Layout assimétrico com bloco split e acentos coral.',
    preview_image: 'https://images.unsplash.com/photo-1606216794074-735e91aa2c92?w=800',
    colors: { primary: '#152238', secondary: '#F2B6A0' },
    style: 'moderno'
  },
  {
    id: 'brutalist-chic',
    name: 'The Brutalist Chic',
    label: 'Urbano Industrial',
    collection: 'Editoriais, Modernos e Moda',
    description: 'Visual industrial com cinza concreto e azul elétrico.',
    preview_image: 'https://images.unsplash.com/photo-1522673607200-164d1b6ce486?w=800',
    colors: { primary: '#3A3A3A', secondary: '#00A3FF' },
    style: 'moderno'
  },
  {
    id: 'dark-editorial',
    name: 'The Dark Editorial',
    label: 'Night Mode Lux',
    collection: 'Editoriais, Modernos e Moda',
    description: 'Dark editorial sofisticado com linhas douradas.',
    preview_image: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800',
    colors: { primary: '#111318', secondary: '#C8A96B' },
    style: 'luxo'
  },
  {
    id: 'boho-pampas',
    name: 'The Boho Pampas',
    label: 'Orgânico e Quente',
    collection: 'Rústicos, Boho e Orgânicos',
    description: 'Boho orgânico com terracotta, sage e texturas naturais.',
    preview_image: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800',
    colors: { primary: '#8A4F3A', secondary: '#8EA37A' },
    style: 'boho'
  },
  {
    id: 'coastal-dune',
    name: 'The Coastal Dune',
    label: 'Praia Minimal',
    collection: 'Rústicos, Boho e Orgânicos',
    description: 'Tema litorâneo claro com bege areia e azul céu.',
    preview_image: 'https://images.unsplash.com/photo-1545579133-99bb5ab189bd?w=800',
    colors: { primary: '#5A8CA8', secondary: '#E9D8B8' },
    style: 'praia'
  },
  {
    id: 'mountain-retreat',
    name: 'The Mountain Retreat',
    label: 'Aventura Floresta',
    collection: 'Rústicos, Boho e Orgânicos',
    description: 'Estética robusta com tons de floresta e madeira.',
    preview_image: 'https://images.unsplash.com/photo-1464822759844-d150ad6d1f8b?w=800',
    colors: { primary: '#1F4B3A', secondary: '#7A5B3C' },
    style: 'rustico'
  },
  {
    id: 'dried-floral-arch',
    name: 'The Dried Floral Arch',
    label: 'Jardim Boho',
    collection: 'Rústicos, Boho e Orgânicos',
    description: 'Paleta suave com dusty rose, lavanda e bege.',
    preview_image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800',
    colors: { primary: '#A07A88', secondary: '#D8C2B1' },
    style: 'romantico'
  },
  {
    id: 'royal-court',
    name: 'The Royal Court',
    label: 'Tradicional Majestoso',
    collection: 'Clássicos e Atemporais',
    description: 'Azul royal, prata e estrutura formal cerimonial.',
    preview_image: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?w=800',
    colors: { primary: '#1C2F5C', secondary: '#C9CDD8' },
    style: 'luxo'
  },
  {
    id: 'ivory-classic',
    name: 'The Ivory Classic',
    label: 'Ateliê Alta Costura',
    collection: 'Clássicos e Atemporais',
    description: 'Clássico de alta costura com marfim e champagne claro.',
    preview_image: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=800',
    colors: { primary: '#3A3732', secondary: '#E9D7B4' },
    style: 'classico'
  },
  {
    id: 'premium-wedding-experience',
    name: 'Premium Wedding Experience',
    label: 'Editorial Premium',
    collection: 'Clássicos e Atemporais',
    description: 'Visual premium inspirado em papelaria editorial de casamento.',
    preview_image: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=800',
    colors: { primary: '#252322', secondary: '#C8A97E' },
    style: 'classico'
  },
  {
    id: 'vintage-lace',
    name: 'The Vintage Lace',
    label: 'Romântico Antigo',
    collection: 'Clássicos e Atemporais',
    description: 'Composição simétrica com renda e molduras clássicas.',
    preview_image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=800',
    colors: { primary: '#6A5752', secondary: '#DCCFC5' },
    style: 'vintage'
  },
  {
    id: 'midnight-ballroom',
    name: 'The Midnight Ballroom',
    label: 'Gala Classic',
    collection: 'Clássicos e Atemporais',
    description: 'Formal noturno com preto profundo e prata cristal.',
    preview_image: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=800',
    colors: { primary: '#0C0E14', secondary: '#BFC6D2' },
    style: 'luxo'
  },
  {
    id: 'vibrant-retro',
    name: 'The Vibrant Retro',
    label: 'Fun Pop',
    collection: 'Joviais, Coloridos e Criativos',
    description: 'Teal, amarelo e pink em clima retrô pop.',
    preview_image: 'https://images.unsplash.com/photo-1529634806980-85c3dd6d34ac?w=800',
    colors: { primary: '#009A9C', secondary: '#FF4FA2' },
    style: 'moderno'
  },
  {
    id: 'pastel-love',
    name: 'The Pastel Love',
    label: 'Doce Suave',
    collection: 'Joviais, Coloridos e Criativos',
    description: 'Tema suave com mint, baby pink e branco.',
    preview_image: 'https://images.unsplash.com/photo-1523821741446-edb2b68bb7a0?w=800',
    colors: { primary: '#6BBFA8', secondary: '#F8B7C8' },
    style: 'romantico'
  },
  {
    id: 'illustrative-day',
    name: 'The Illustrative Day',
    label: 'Arte Fofura',
    collection: 'Joviais, Coloridos e Criativos',
    description: 'Linguagem ilustrada com atmosfera lúdica e afetiva.',
    preview_image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800',
    colors: { primary: '#5C6AC4', secondary: '#FFB5A7' },
    style: 'jardim'
  },
  {
    id: 'geometric-punch',
    name: 'The Geometric Punch',
    label: 'Moderno Arrojado',
    collection: 'Joviais, Coloridos e Criativos',
    description: 'Composição forte com blocos geométricos e alto contraste.',
    preview_image: 'https://images.unsplash.com/photo-1532712938310-34cb3982ef74?w=800',
    colors: { primary: '#4A256B', secondary: '#FF6A00' },
    style: 'moderno'
  },
  {
    id: 'digital-dream',
    name: 'The Digital Dream',
    label: 'Tech Futurista',
    collection: 'Temáticos e Conceituais',
    description: 'Visual tech clean com acentos cyber blue.',
    preview_image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800',
    colors: { primary: '#12223A', secondary: '#48C4FF' },
    style: 'minimalista'
  },
  {
    id: 'travel-log',
    name: 'The Travel Log',
    label: 'Aventura Nômade',
    collection: 'Temáticos e Conceituais',
    description: 'Narrativa de viagem com tons de céu e couro.',
    preview_image: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800',
    colors: { primary: '#3D6C8C', secondary: '#8A5A3A' },
    style: 'rustico'
  },
  {
    id: 'botanical-sketch',
    name: 'The Botanical Sketch',
    label: 'Jardim Minimal',
    collection: 'Temáticos e Conceituais',
    description: 'Branco, verde-tinta e line art botânico contínuo.',
    preview_image: 'https://images.unsplash.com/photo-1478147427282-58a87a120781?w=800',
    colors: { primary: '#2E5243', secondary: '#8EB89D' },
    style: 'jardim'
  },
  {
    id: 'watercolor-bloom',
    name: 'The Watercolor Bloom',
    label: 'Artístico Suave',
    collection: 'Temáticos e Conceituais',
    description: 'Base clara com lavagens aquareladas românticas.',
    preview_image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800',
    colors: { primary: '#5E6E9E', secondary: '#E7A8BD' },
    style: 'romantico'
  }
];

export const TEMPLATE_THEME_MAP = WEDDING_TEMPLATES.reduce((acc, template) => {
  acc[template.id] = template.colors;
  return acc;
}, {});

export const TEMPLATE_STYLE_MAP = WEDDING_TEMPLATES.reduce((acc, template) => {
  acc[template.id] = template.style;
  return acc;
}, {});

export const TEMPLATE_LOOKUP = WEDDING_TEMPLATES.reduce((acc, template) => {
  acc[template.id] = template;
  return acc;
}, {});

export const LEGACY_TEMPLATE_ALIASES = {
  'classic-editorial': 'classic-editorial',
  'botanical-garden': 'botanical-garden',
  'modern-black-tie': 'modern-black-tie',
  'destination-praia': 'destination-praia',
  'minimal-classic': 'minimal-classic',
  'vintage-retro': 'vintage-retro',
  'scandinavian-minimal': 'scandinavian-minimal',
  'por-do-sol': 'por-do-sol',
  'noir-dorado': 'noir-dorado',
  'terra-flores': 'terra-flores',
  'linha-pura': 'linha-pura',
  'jardim-secreto': 'jardim-secreto',
  'art-deco': 'art-deco',
  'praia-brisa': 'praia-brisa',
  'inverno-real': 'inverno-real',
  'veludo-rosa': 'veludo-rosa',
  'tipo-gigante': 'tipo-gigante',
  'sakura': 'sakura',
  'serra-nevoa': 'serra-nevoa',
  'parisiense': 'parisiense',
  'tropical': 'tropical',
  'prata-eterno': 'prata-eterno',
  'bohemia': 'bohemia',
  'noite-estrelada': 'noite-estrelada',
  'azulejo-portugues': 'azulejo-portugues',
  'azulejo-portugues': 'azulejo-portugues',
  'azulejo-português': 'azulejo-portugues',
  'praia-brisa': 'praia-brisa',
  'sunset-romance': 'por-do-sol',
  escandinavo: 'scandinavian-minimal',
  classico: 'ivory-classic',
  classic: 'ivory-classic',
  moderno: 'asymmetric-flow',
  modern: 'asymmetric-flow',
  rustico: 'mountain-retreat',
  rustic: 'mountain-retreat',
  minimalista: 'ethereal-grid',
  minimal: 'ethereal-grid',
  romantico: 'dried-floral-arch',
  romantic: 'dried-floral-arch',
  jardim: 'botanical-sketch',
  garden: 'botanical-sketch',
  praia: 'coastal-dune',
  beach: 'coastal-dune',
  luxo: 'royal-court',
  luxury: 'royal-court',
  boho: 'boho-pampas',
  vintage: 'vintage-lace',
  premium: 'premium-wedding-experience',
  'premium-wedding': 'premium-wedding-experience'
};

export const resolveTemplateId = (templateId) => {
  if (!templateId) return 'ivory-classic';
  return LEGACY_TEMPLATE_ALIASES[templateId] || templateId;
};
